import { Post, PostJson } from "../core/Helper";

export class Branch {}

export class BranchService {
  static async GetItem(data, user) {
    let result = await PostJson("/api/branch-new/get-item-new", {
      data,
      user,
    });
    return result ?? null;
  }

  static async GetNewList(data, user) {
    let result = await PostJson("/api/branch-new/getlist", {
      data,
      user,
    });
    return result ?? null;
  }

  static async GetList(params) {
    let result = await Post("api/branch/select", params);
    return (await result.lists) ?? null;
  }

  static async Delete(params) {
    let result = await Post("api/branch/delete", params);
    return (await result.lists) ?? null;
  }

  static async GetReportStudy(params) {
    let result = await Post("api/branch/getreport-study", params);
    return (await result.lists) ?? null;
  }
}
